import { render, staticRenderFns } from "./Close.vue?vue&type=template&id=65533fe6&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Close.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Close.vue
// module id = 2208
// module chunks = 1